document.addEventListener('DOMContentLoaded', () => {
  const footerButton = document.querySelector('[data-mr-footer-submit]');
  const footerEmail = document.querySelector('[data-mr-footer-email]');
  const modalRoot = document.querySelector('#mr-newsletter-modal');
  const modalPanel = modalRoot?.querySelector('.mr-newsletter-modal__panel');
  const closeButtons = modalRoot?.querySelectorAll('[data-mr-newsletter-close]');
  const newsletterMode = modalRoot?.querySelector('[data-mr-modal-mode="newsletter"]');
  const notifyMode = modalRoot?.querySelector('[data-mr-modal-mode="notify"]');
  const formState = modalRoot?.querySelector('[data-mr-modal-form-state]');
  const successState = modalRoot?.querySelector('[data-mr-modal-success-state]');
  const newsletterSuccess = modalRoot?.querySelector('[data-mr-modal-success-mode="newsletter"]');
  const notifySuccess = modalRoot?.querySelector('[data-mr-modal-success-mode="notify"]');
  const modalSource = modalRoot?.querySelector('input[name="contact[note][signup_source]"]');
  const newsletterEmail = modalRoot?.querySelector('#mr-newsletter-email');
  const notifyEmail = modalRoot?.querySelector('#mr-restock-email');
  const modalForm = document.querySelector('#mr-newsletter-modal-form');
  const restockForm = document.querySelector('#mr-restock-modal-form');
  const restockSummary = modalRoot?.querySelector('[data-mr-restock-product-summary]');
  const restockProductTitle = modalRoot?.querySelector('[data-mr-restock-product-title]');
  const restockVariantTitle = modalRoot?.querySelector('[data-mr-restock-variant-title]');
  const restockFields = modalRoot?.querySelectorAll('[data-mr-restock-field]') || [];
  const newsletterPostedMarker = modalRoot?.querySelector('[data-mr-newsletter-posted="true"]');
  const restockPostedMarker = modalRoot?.querySelector('[data-mr-restock-posted="true"]');

  if (!modalRoot || !modalPanel) return;

  const POPUP_DELAY = 5000;
  const DISMISS_DAYS = 14;
  const PENDING_DAYS = 7;

  const STORAGE_KEY_DISMISSED = 'mr_newsletter_dismissed_until';
  const STORAGE_KEY_PENDING = 'mr_newsletter_pending_until';
  const SESSION_KEY_SUCCESS_SHOWN = 'mr_newsletter_success_shown';
  const SESSION_KEY_RESTOCK_SUCCESS_SHOWN = 'mr_restock_success_shown';

  let currentMode = 'newsletter';
  let activeTrigger = null;
  let scrollLockY = 0;

  function isHomePage() {
    return (
      window.location.pathname === '/' ||
      document.body.classList.contains('template-index')
    );
  }

  function getFutureTimestamp(days) {
    return Date.now() + days * 24 * 60 * 60 * 1000;
  }

  function isFutureTimestampActive(key) {
    const rawValue = window.localStorage.getItem(key);
    if (!rawValue) return false;

    const timestamp = Number(rawValue);
    if (!timestamp) return false;

    return Date.now() < timestamp;
  }

  function setFutureTimestamp(key, days) {
    window.localStorage.setItem(key, String(getFutureTimestamp(days)));
  }

  function clearStorageKey(key) {
    window.localStorage.removeItem(key);
  }

  function isDismissed() {
    return isFutureTimestampActive(STORAGE_KEY_DISMISSED);
  }

  function setDismissed(days = DISMISS_DAYS) {
    setFutureTimestamp(STORAGE_KEY_DISMISSED, days);
  }

  function clearDismissed() {
    clearStorageKey(STORAGE_KEY_DISMISSED);
  }

  function isPendingConfirmation() {
    return isFutureTimestampActive(STORAGE_KEY_PENDING);
  }

  function setPendingConfirmation(days = PENDING_DAYS) {
    setFutureTimestamp(STORAGE_KEY_PENDING, days);
  }

  function clearPendingConfirmation() {
    clearStorageKey(STORAGE_KEY_PENDING);
  }

  function lockBodyScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('mr-newsletter-modal-open');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollLockY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBodyScroll() {
    document.body.classList.remove('mr-newsletter-modal-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollLockY);
  }

  function setModalMode(mode) {
    currentMode = mode === 'notify' ? 'notify' : 'newsletter';

    if (newsletterMode) newsletterMode.hidden = currentMode !== 'newsletter';
    if (notifyMode) notifyMode.hidden = currentMode !== 'notify';
  }

  function setSuccessMode(mode) {
    if (newsletterSuccess) newsletterSuccess.hidden = mode !== 'newsletter';
    if (notifySuccess) notifySuccess.hidden = mode !== 'notify';
  }

  function showFormState(mode = currentMode) {
    setModalMode(mode);
    if (formState) formState.hidden = false;
    if (successState) successState.hidden = true;
  }

  function showSuccessState(mode = currentMode) {
    currentMode = mode === 'notify' ? 'notify' : 'newsletter';
    setSuccessMode(currentMode);
    if (formState) formState.hidden = true;
    if (successState) successState.hidden = false;
  }

  function getVariantLabel(value, defaultValue = 'Default Title') {
    if (!value) return '';
    if (value === 'Default Title' || value === defaultValue) return '';
    return value;
  }

  function buildVariantUrl(baseUrl, variantId) {
    if (!baseUrl) return window.location.href;

    try {
      const resolved = new URL(baseUrl, window.location.origin);
      if (variantId) {
        resolved.searchParams.set('variant', variantId);
      }
      return resolved.toString();
    } catch (error) {
      if (!variantId) return baseUrl;
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}variant=${variantId}`;
    }
  }

  function buildRestockMessage(data) {
    const lines = [
      'Back in stock request',
      `Product: ${data.productTitle || ''}`,
      `Variant: ${data.variantTitle || 'Default'}`,
      `Variant ID: ${data.variantId || ''}`,
      `SKU: ${data.sku || ''}`,
      `Product URL: ${data.productUrl || ''}`,
      `Page URL: ${data.pageUrl || ''}`,
      `Requested at: ${data.requestedAt || ''}`,
    ];

    return lines.join('\n');
  }

  function populateRestockFields(trigger) {
    if (!trigger) return;

    const defaultVariantTitle = trigger.dataset.defaultVariantTitle || 'Default Title';
    const productTitle = trigger.dataset.productTitle || '';
    const variantTitle = getVariantLabel(trigger.dataset.variantTitle || '', defaultVariantTitle);
    const variantId = trigger.dataset.variantId || '';
    const sku = trigger.dataset.variantSku || '';
    const productUrl = buildVariantUrl(trigger.dataset.productUrl || window.location.href, variantId);
    const pageUrl = window.location.href;
    const requestedAt = new Date().toISOString();

    if (restockSummary) {
      restockSummary.hidden = !productTitle;
    }

    if (restockProductTitle) {
      restockProductTitle.textContent = productTitle;
    }

    if (restockVariantTitle) {
      if (variantTitle) {
        restockVariantTitle.hidden = false;
        restockVariantTitle.textContent = variantTitle;
      } else {
        restockVariantTitle.hidden = true;
        restockVariantTitle.textContent = '';
      }
    }

    restockFields.forEach((field) => {
      const key = field.getAttribute('data-mr-restock-field');

      const valueMap = {
        product_title: productTitle,
        variant_title: variantTitle,
        variant_id: variantId,
        sku,
        product_url: productUrl,
        page_url: pageUrl,
        requested_at: requestedAt,
        body: buildRestockMessage({
          productTitle,
          variantTitle,
          variantId,
          sku,
          productUrl,
          pageUrl,
          requestedAt,
        }),
      };

      field.value = valueMap[key] || '';
    });
  }

  function openModal({ mode = 'newsletter', source = 'modal', prefillEmail = '', trigger = null } = {}) {
    activeTrigger = trigger || document.activeElement;
    if (mode === 'newsletter') {
      if (modalSource) {
        modalSource.value = source;
      }
      if (newsletterEmail && prefillEmail) {
        newsletterEmail.value = prefillEmail;
      }
    }

    if (mode === 'notify') {
      populateRestockFields(trigger);
      if (notifyEmail && prefillEmail) {
        notifyEmail.value = prefillEmail;
      }
    }

    showFormState(mode);

    modalRoot.hidden = false;
    modalRoot.setAttribute('aria-hidden', 'false');
    lockBodyScroll();

    window.setTimeout(() => {
      const activeInput = mode === 'notify' ? notifyEmail : newsletterEmail;
      if (!activeInput) return;

      activeInput.focus();
      const len = activeInput.value.length;

      try {
        activeInput.setSelectionRange(len, len);
      } catch (error) {}
    }, 20);
  }

  function openSuccessModal(mode = 'newsletter') {
    modalRoot.hidden = false;
    modalRoot.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mr-newsletter-modal-open');
    showSuccessState(mode);
  }

  function closeModal(markDismissed = true) {
    modalRoot.hidden = true;
    modalRoot.setAttribute('aria-hidden', 'true');
    unlockBodyScroll();

    if (activeTrigger && typeof activeTrigger.focus === 'function') {
      try {
        activeTrigger.focus({ preventScroll: true });
      } catch (error) {
        activeTrigger.focus();
      }
    }

    if (markDismissed && currentMode === 'newsletter') {
      setDismissed();
    }
  }

  function getAddToCartButton(productForm) {
    return productForm?.querySelector('[ref="addToCartButton"]');
  }

  function getSoldOutStateFromAddToCartButton(productForm) {
    const addToCartButton = getAddToCartButton(productForm);

    if (!addToCartButton) return null;

    const buttonText = (addToCartButton.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const isDisabled =
      addToCartButton.disabled ||
      addToCartButton.getAttribute('aria-disabled') === 'true';

    if (!buttonText) return null;
    if (buttonText.includes('add to cart')) return false;
    if (isDisabled && (buttonText.includes('sold out') || buttonText.includes('out of stock'))) {
      return true;
    }

    return false;
  }

  function shouldShowRestockButton(productForm, variant, data = {}) {
    if (typeof variant?.available === 'boolean') {
      productForm.dataset.mrCurrentVariantAvailable = variant.available ? 'true' : 'false';
      return variant.available === false;
    }

    const nextHtmlVariant = data?.html?.querySelector?.('product-form-component [name="id"]')?.value;
    if (nextHtmlVariant && typeof data?.resource?.available === 'boolean') {
      productForm.dataset.mrCurrentVariantAvailable = data.resource.available ? 'true' : 'false';
      return data.resource.available === false;
    }

    const soldOutStateFromButton = getSoldOutStateFromAddToCartButton(productForm);
    if (typeof soldOutStateFromButton === 'boolean') {
      productForm.dataset.mrCurrentVariantAvailable = soldOutStateFromButton ? 'false' : 'true';
      return soldOutStateFromButton;
    }

    const availabilityFlag = productForm?.dataset?.mrCurrentVariantAvailable;
    if (availabilityFlag === 'true' || availabilityFlag === 'false') {
      return availabilityFlag === 'false';
    }

    return false;
  }

  function syncRestockButton(productForm, variant, data = {}) {
    if (!productForm) return;

    const restockButtonContainer = productForm.querySelector('[ref="restockButtonContainer"]');
    const restockButton = restockButtonContainer?.querySelector('[data-mr-restock-trigger]');
    const isSoldOut = shouldShowRestockButton(productForm, variant, data);

    if (restockButtonContainer) {
      restockButtonContainer.hidden = !isSoldOut;
      restockButtonContainer.setAttribute('aria-hidden', isSoldOut ? 'false' : 'true');
    }

    if (!restockButton) return;

    if (!variant) {
      restockButton.dataset.productUrl = productForm.dataset.productUrl || restockButton.dataset.productUrl || window.location.pathname;
      return;
    }

    const defaultVariantTitle = restockButton.dataset.defaultVariantTitle || 'Default Title';
    const nextProductUrl = data.newProduct?.url || productForm.dataset.productUrl || restockButton.dataset.productUrl || window.location.pathname;

    restockButton.dataset.variantId = variant.id ? String(variant.id) : '';
    restockButton.dataset.variantTitle = getVariantLabel(variant.title || '', defaultVariantTitle);
    restockButton.dataset.variantSku = variant.sku || '';
    restockButton.dataset.productUrl = buildVariantUrl(nextProductUrl, variant.id ? String(variant.id) : '');
  }

  function syncRestockButtonAfterUpdate(productForm, variant, data = {}) {
    syncRestockButton(productForm, variant, data);

    window.requestAnimationFrame(() => {
      syncRestockButton(productForm, variant, data);

      window.requestAnimationFrame(() => {
        syncRestockButton(productForm, variant, data);
      });
    });

    window.setTimeout(() => {
      syncRestockButton(productForm, variant, data);
    }, 120);
  }

  function bindRestockListeners() {
    const productForms = document.querySelectorAll('product-form-component');

    productForms.forEach((productForm) => {
      const target = productForm.closest('.shopify-section, dialog, product-card');
      const addToCartButton = getAddToCartButton(productForm);
      const restockButtonContainer = productForm.querySelector('[ref="restockButtonContainer"]');

      if (restockButtonContainer) {
        restockButtonContainer.hidden = true;
        restockButtonContainer.setAttribute('aria-hidden', 'true');
      }

      syncRestockButtonAfterUpdate(productForm);

      if (addToCartButton && !addToCartButton.dataset.mrRestockObserved) {
        addToCartButton.dataset.mrRestockObserved = 'true';

        const observer = new MutationObserver(() => {
          syncRestockButtonAfterUpdate(productForm);
        });

        observer.observe(addToCartButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class', 'aria-disabled'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      if (!target || productForm.dataset.mrRestockBound === 'true') return;

      productForm.dataset.mrRestockBound = 'true';

      target.addEventListener('variant:update', (event) => {
        const eventProductId = event.detail?.data?.productId;
        const newProduct = event.detail?.data?.newProduct;

        if (newProduct?.id) {
          productForm.dataset.productId = String(newProduct.id);
          if (newProduct.url) {
            productForm.dataset.productUrl = newProduct.url;
          }
        } else if (eventProductId && productForm.dataset.productId && String(eventProductId) !== String(productForm.dataset.productId)) {
          return;
        }

        syncRestockButtonAfterUpdate(productForm, event.detail?.resource, event.detail?.data || {});
      });
    });
  }

  if (footerButton) {
    footerButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const emailValue = footerEmail?.value?.trim() || '';
      openModal({
        mode: 'newsletter',
        source: 'footer_modal',
        prefillEmail: emailValue,
      });
    });
  }

  if (footerEmail && footerButton) {
    footerEmail.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        footerButton.click();
      }
    });
  }

  document.addEventListener('click', (event) => {
    const eventTarget = event.target instanceof Element ? event.target : null;
    const trigger = eventTarget?.closest('[data-mr-restock-trigger]');

    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    openModal({
      mode: 'notify',
      source: 'notify_me_button',
      trigger,
    });
  });

  closeButtons?.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      closeModal(true);
    });
  });

  modalRoot.addEventListener('click', (event) => {
    if (!modalPanel.contains(event.target)) {
      closeModal(true);
    }
  });

  modalPanel.addEventListener('click', (event) => {
    event.stopPropagation();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !modalRoot.hidden) {
      closeModal(true);
    }
  });

  if (modalForm) {
    modalForm.addEventListener('submit', () => {
      clearDismissed();
      setPendingConfirmation();
      sessionStorage.setItem(SESSION_KEY_SUCCESS_SHOWN, 'true');
      showSuccessState('newsletter');

      window.setTimeout(() => {
        closeModal(false);
      }, 7500);
    });
  }

  if (restockForm) {
    restockForm.addEventListener('submit', () => {
      sessionStorage.setItem(SESSION_KEY_RESTOCK_SUCCESS_SHOWN, 'true');
    });
  }

  const searchParams = new URLSearchParams(window.location.search);
  const shopifyContactPosted =
    searchParams.get('customer_posted') === 'true' ||
    window.location.hash === '#contact_form';

  if (restockPostedMarker && sessionStorage.getItem(SESSION_KEY_RESTOCK_SUCCESS_SHOWN) !== 'shown') {
    sessionStorage.setItem(SESSION_KEY_RESTOCK_SUCCESS_SHOWN, 'shown');
    openSuccessModal('notify');
  } else if ((newsletterPostedMarker || shopifyContactPosted) && sessionStorage.getItem(SESSION_KEY_SUCCESS_SHOWN) !== 'true') {
    clearDismissed();
    setPendingConfirmation();
    sessionStorage.setItem(SESSION_KEY_SUCCESS_SHOWN, 'true');
    openSuccessModal('newsletter');
  }

  const shouldAutoOpen =
    isHomePage() &&
    !isDismissed() &&
    !isPendingConfirmation() &&
    modalRoot.hidden;

  if (shouldAutoOpen) {
    window.setTimeout(() => {
      const stillShouldOpen =
        isHomePage() &&
        !isDismissed() &&
        !isPendingConfirmation() &&
        modalRoot.hidden;

      if (stillShouldOpen) {
        openModal({
          mode: 'newsletter',
          source: 'timed_popup',
        });
      }
    }, POPUP_DELAY);
  }

  bindRestockListeners();
});
